import React, { useState } from 'react'
import './LeaveAdminApplication.scss'
import { BreadCrumb } from 'Components'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { useNavigate, useParams } from 'react-router-dom'
import { leaveService } from '../../../../../../Services/leaveService'

export type leaveFormType = {
  startDate: Date | undefined | null
  endDate: Date | undefined | null
  leaveType: string | undefined
  days: number
  reason: string
  handoverNote: string
  relieverEmailAddress: string
}

const LeaveAdminApplication = () => {
  const [request, setRequest] = useState(false)
  const navigate = useNavigate()
  const { leave_type, user } = useParams<{
    leave_type: string | undefined
    user: string | undefined
  }>()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<leaveFormType>()

  const submit = async (data: leaveFormType) => {
    setRequest(true)
    await leaveService.create({ ...data, leaveType: leave_type }).then(
      () => {
        setRequest(false)
        Swal.fire({
          icon: 'success',
          title: 'Congratulations!',
          text: 'Your leave application has been submitted successfully',
          showConfirmButton: false,
          timer: 3000,
        })

        setTimeout(() => {
          navigate('/leave')
        }, 2000)
      },
      (error: { response: { data: { error: string } } }) => {
        console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  return (
    <div className='LeaveApplication me-md-3'>
      <div className='container'>
        <BreadCrumb
          title={'Leave Application'}
          parent={'leave'}
          parentUrl={'/leave'}
          showTitle={false}
        ></BreadCrumb>
      </div>

      <div className='container mt-5'>
        <div className='card border-0 px-4 pt-3 mx-md-3'>
          <div className='card-header px-0'>Annual Leave Application Form</div>
          <div className='card-body px-0'>
            <form onSubmit={handleSubmit(submit)}>
              <div className='row'>
                <div className='form-group col-md-6 mt-3'>
                  <label htmlFor=''>Start Date</label>
                  <input
                    type='date'
                    {...register('startDate', {
                      required: 'Start date is required',
                    })}
                    className={`form-control ${errors.startDate ? 'is-invalid' : ''}`}
                  />
                  {errors.startDate && (
                    <div className='invalid-feedback'>{errors.startDate.message}</div>
                  )}
                </div>

                <div className='form-group col-md-6 mt-3'>
                  <label htmlFor=''>End Date</label>
                  <input
                    type='date'
                    {...register('endDate', {
                      required: 'End date is required',
                    })}
                    className={`form-control ${errors.endDate ? 'is-invalid' : ''}`}
                  />
                  {errors.endDate && (
                    <div className='invalid-feedback'>{errors.endDate.message}</div>
                  )}
                </div>

                <div className='form-group col-md-6 mt-3'>
                  <label htmlFor=''>Total Number of Leave Days</label>
                  <input
                    type='text'
                    className={`form-control ${errors.days ? 'is-invalid' : ''}`}
                    {...register('days', {
                      required: 'Number of days is required',
                    })}
                  />
                  {errors.days && <div className='invalid-feedback'>{errors.days.message}</div>}
                </div>

                <div className='form-group col-md-6 mt-3'>
                  <label htmlFor=''>Reason for Leave</label>
                  <input
                    type='text'
                    className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
                    {...register('reason', {
                      required: 'Reason for the leave is required',
                    })}
                  />
                  {errors.reason && <div className='invalid-feedback'>{errors.reason.message}</div>}
                </div>

                <div className='form-group col-md-6 mt-3'>
                  <label htmlFor=''>Address During Leave</label>
                  <input type='text' className='form-control' />
                </div>

                <div className='form-group col-md-6 mt-3'>
                  <label htmlFor=''>Emergency Contact Number</label>
                  <input type='text' className='form-control' />
                </div>

                <div className='col-md-6'></div>
                <div className='form-group mt-3 col-md-6 text-md-end'>
                  <button type='submit' className='btn btn-default mt-4' disabled={request}>
                    {request && <span className='spinner-border-spinner-sm'></span>}
                    Apply for Loan
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeaveAdminApplication
